import MobileNumber from "./MobileNumberComponent";

export default MobileNumber;
